import React, { Component } from "react";
import { connect } from "react-redux";
// import {change_header} from '../../../redux/actions/HeroBarAction'
import {
  set_datapage,
  SetLanguage,
  getLanguage,
} from "@ora/recursos/src/redux/actions/DataPageAction";

import { Button, Card, Section, Form } from "react-bulma-components";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import $ from "jquery";
import dt from "datatables.net";
import { Link, Redirect, useHistory } from "react-router-dom";
import { tagActivo, buttonsAcciones } from "helpers/Datatables";
import Swal from "sweetalert2";
import { PageLength } from "helpers/Datatables";
import SpinLoader from "layouts/mainsection/components/SpinLoader";
// import React from "react";
$.DataTable = dt;

class ResumenTematica extends Component {
  state = {
    body: [],
    listType: [],
    listPais: [],
    isloadsearch: true,
    total: "",
  };
  filter = {
    buscar: "",
    type: -1,
  };
  table = null;
  datatable = null;
  requestInit = null
  keymodulo=''
  constructor(props) {
    super(props);
    let { modulo } = this.props.match.params
    if (modulo !== undefined) {
      this.keymodulo = modulo
    }
    this.requestInit = axios.CancelToken.source()
  }
  componentDidMount() {
    this.props.set_datapage({
      titulo: "Resumen de Recursos por Línea Temática"
    });
    this.setState({
      body: (
        <tr key="empty">
          <td className="has-text-centered" colSpan="6">
            <SpinLoader/>
          </td>
        </tr>
      )
    })
    this.getData()
  }
  componentWillUnmount () {
    if (this.requestInit) this.requestInit.cancel()
  }
  getData = () => {
    axios.get(baseUrl('cites/intranet/reportes/resumen_tematica_recurso/'+this.keymodulo), {cancelToken: this.requestInit.token}).then(res => {
      let body = []
      if(res.data.modulo!=null){
        res.data?.resumen?.forEach((item, index) => {
          var totales ={}
          if (item.data.length > 0) {
            totales = {
              metadatos: 0,
              tabulares: 0,
              cartograficos: 0,
              documentales: 0
            }
          }
          if(item.data.length>0){
            body.push(
            <React.Fragment key={'B' + index}>
              { item.data.map((itemD, indexD) => {
                totales.metadatos += +itemD.total_recursos
                totales.tabulares += +itemD.rec_tabulares
                totales.cartograficos += +itemD.rec_cartograficos
                totales.documentales += +itemD.rec_documentales
                return (
                  <tr key={ `RES${index}${indexD}` }>
                    <td>{ indexD === 0 ? ((index+1)+' - '+item.tematica) : '' }</td>
                    <td>{indexD+1} - { itemD.institucion }</td>
                    <td className="has-text-centered">
                      <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q5=${itemD.institucion_id}&showi=1&modulo=${this.keymodulo}`
                        }}>{ itemD.total_recursos }</Link></td>
                    <td className="has-text-centered">
                      <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q5=${itemD.institucion_id}&q6=tabular_resources&showi=1&modulo=${this.keymodulo}`
                        }}>{ itemD.rec_tabulares }</Link></td>
                    <td className="has-text-centered">
                    <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q5=${itemD.institucion_id}&q6=cartographic_resources&showi=1&modulo=${this.keymodulo}`
                        }}>{ itemD.rec_cartograficos }</Link>
                      
                      </td>
                    <td className="has-text-centered">
                    <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q5=${itemD.institucion_id}&q6=document_resources&showi=1&modulo=${this.keymodulo}`
                        }}>{ itemD.rec_documentales }</Link>
                      
                      </td>
                  </tr>
                )
              })}
            </React.Fragment>
            )}else{
            body.push(
              <React.Fragment key={'B00'}>
                <tr key={ `RES00` }>
                    <td>{item.tematica}</td>
                    <td>-</td>
                    <td className="has-text-centered">
                      <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&showi=1&modulo=${this.keymodulo}`
                        }}>0</Link></td>
                    <td className="has-text-centered">
                      <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&showi=1&modulo=${this.keymodulo}`
                        }}>0</Link></td>
                    <td className="has-text-centered">
                      <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&showi=1&modulo=${this.keymodulo}`
                        }}>0</Link>                    
                      </td>
                    <td className="has-text-centered">
                      <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&showi=1&modulo=${this.keymodulo}`
                        }}>0</Link>
                      
                      </td>
                  </tr>
              </React.Fragment>
            )
            }
            if(item.data.length>0){
            body.push(
              <React.Fragment key={'T' + index}>
                <tr key={ `TOT${index}` } style={{backgroundColor: '#9ea0e2'}}>
                  <td colSpan="2" style={{textAlign: 'right'}}>{ `Total ${item.tematica}` }</td>
                  <td className="has-text-centered">
                    <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&showi=1&modulo=${this.keymodulo}`
                        }}>{ totales.metadatos }</Link></td>
                  <td className="has-text-centered">
                    <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q6=tabular_resources&showi=1&modulo=${this.keymodulo}`
                        }}>{ totales.tabulares }</Link></td>
                  <td className="has-text-centered">
                  <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q6=cartographic_resources&showi=1&modulo=${this.keymodulo}`
                        }}>{ totales.cartograficos }</Link>
                    
                    </td>
                  <td className="has-text-centered">
                  <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q6=document_resources&showi=1&modulo=${this.keymodulo}`
                        }}>{ totales.documentales }</Link></td>
                </tr>
              </React.Fragment>
            )
            }else{
              body.push(
                <React.Fragment key={'T' + index}>
                  <tr key={ `TOT${index}` } style={{backgroundColor: '#9ea0e2'}}>
                    <td colSpan="2" style={{textAlign: 'right'}}>{ `Total ${item.tematica}` }</td>
                    <td className="has-text-centered">0</td>
                    <td className="has-text-centered">0</td>
                    <td className="has-text-centered">0</td>
                    <td className="has-text-centered">0</td>
                  </tr>
                </React.Fragment>
              )
            }
          
        })
        body.push(<React.Fragment key={'Bnew'}><tr key={ `new` }><td colSpan="6"></td></tr></React.Fragment>)

        body.push(<React.Fragment key={'Bnewline'}><tr key={ `otro_new` }  style={{backgroundColor: '#8ed26b'}}><td>Otro países</td><td>Otras Instituciones</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        </tr></React.Fragment>)
        res.data?.otros?.forEach((item, index) => {
          if (item.data.length > 0) {
            let totales = {
              metadatos: 0,
              tabulares: 0,
              cartograficos: 0,
              documentales: 0
            }
            body.push(
            <React.Fragment key={'O' + index}>
              { item.data.map((itemD, indexD) => {
                totales.metadatos += +itemD.total_recursos
                totales.tabulares += +itemD.rec_tabulares
                totales.cartograficos += +itemD.rec_cartograficos
                totales.documentales += +itemD.rec_documentales
                return (
                  <tr key={ `OTRO${index}${indexD}` }>
                    <td>{ indexD === 0 ? item.tematica : '' }</td>
                    <td>{ itemD.institucion }</td>
                    <td className="has-text-centered"><Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q5=${itemD.institucion_id}&showi=1&modulo=${this.keymodulo}`
                        }}>{ itemD.total_recursos }</Link></td>
                    <td className="has-text-centered">
                    <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q5=${itemD.institucion_id}&q6=tabular_resources&showi=1&modulo=${this.keymodulo}`
                        }}>{ itemD.rec_tabulares }</Link>
                      </td>
                      <td className="has-text-centered">
                    <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q5=${itemD.institucion_id}&q6=cartographic_resources&showi=1&modulo=${this.keymodulo}`
                        }}>{ itemD.rec_cartograficos }</Link>
                      
                      </td>
                    <td className="has-text-centered">
                    <Link target="_blank"
                        style={{
                          borderBottom: '1px dotted black'
                        }}
                        to={{
                          pathname: localUrl("/reportes/listarecursos"),
                          search: `?q3=${item.tematica_id}&q5=${itemD.institucion_id}&q6=document_resources&showi=1&modulo=${this.keymodulo}`
                        }}>{ itemD.rec_documentales }</Link>
                      
                      </td>
                  </tr>
                )
              })}
            </React.Fragment>
            )
        
          }
        })

        this.props.set_datapage({
          titulo: "Resumen de Recursos por Línea Temática - "+res.data.modulo.var_txt_name
        });
      }else{
        body.push((
          <tr key="empty">
            <td className="has-text-centered" colSpan="6">
              No se encontraron resultados!...
            </td>
          </tr>
        ))
      }
      this.setState({
        body
      })
    })
  }
  render() {
    return (
      <Section className="is-main-section">
        <Card>
          {/* <Card.Header> */}
          {/* <Card.Header.Title>
                     <span className="icon"><i className="mdi mdi-finance"></i></span>Importar
                 </Card.Header.Title> */}

          {/* </Card.Header> */}
          <Card.Content>
            <div className="table-wrapper has-mobile-cards table-container">
              <table className="table db-trafico is-striped is-hoverable">
                <thead>
                  <tr>
                    <th
                      draggable="false"
                      className="is-sortable is-unselectable is-current-sort"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">Líneas Temáticas</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">Instituciones Públicas de los Países Miembros</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">Metadatos</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">Recursos Tabulares</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">Recursos Cartográficos</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">Recursos Documentales</span>
                      </div>
                    </th>
                    
                  </tr>
                </thead>
                <tbody>{this.state.body}</tbody>
                {/* {this.state.modals} */}
              </table>
            </div>
          </Card.Content>
        </Card>
      </Section>
    );
  }
}

export default connect(getLanguage, { set_datapage, SetLanguage })(
  ResumenTematica
);
